import { Search } from '@profgeosoft-ui/icons';
import { Input, RadioButtonGroup } from '@profgeosoft-ui/react';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';

import { useStore } from 'src/store';
import { GOPLAN_COLOR_PALETTE_EDITING } from 'src/store/roles-store/roles';

import { ColorsBlock } from './colors-block';
import { DirectoriesList } from './directories-list';
import styles from './palette-settings.module.scss';
import type { PaletteSettingsStore } from './palette-settings.store';

type Props = {
  store: PaletteSettingsStore;
};

export const PaletteSettings = observer<Props>(function PaletteSettings({ store }) {
  const { rolesStore } = useStore();
  const directoriesStatusGroupsIds = useMemo(() => {
    return [
      {
        label: 'Активные',
        value: 'active',
      },
      {
        label: 'Архивные',
        value: 'archived',
      },
    ];
  }, []);

  useEffect(() => {
    return store.init();
  }, [store]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.headersBlock}>
        <RadioButtonGroup
          size="l"
          className={styles.radioGroup}
          value={store.dictsStatus}
          items={directoriesStatusGroupsIds}
          onChange={(v) => {
            if (v === 'active' || v === 'archived') {
              store.setDictsStatus(v);
            }
          }}
        />
        {/* // TODO: localization */}
        <Input
          value={store.searchValue}
          onChange={(e) => store.setSearchValue(e.target.value)}
          className={styles.searchInput}
          prefix={<Search />}
          placeholder="Поиск"
        />
      </div>
      <div className={styles.contentWrapper}>
        <DirectoriesList store={store} />
        <div className={styles.divider} />
        {rolesStore.hasAccess([GOPLAN_COLOR_PALETTE_EDITING]) && <ColorsBlock store={store} />}
      </div>
    </div>
  );
});
